'use client';
import { useState, useEffect } from 'react';

let r = Math.random().toString(36).substring(2, 11), n = 0;
function setAutoIdSignature(t) {
    r = t;
}
function resetAutoId(t) {
    r = t, n = 0;
}
function generateId() {
    return n += 1, `auto-id-${r}-${n}`;
}
const useId = (r)=>{
    let [n, o] = useState(null != r ? r : void 0);
    return useEffect(()=>{
        o((t)=>t || generateId());
    }, []), n;
};

export { resetAutoId, setAutoIdSignature, useId };
